module.exports = "/static/Images/images/Unsatisfied.png";